import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { classes, keyframes, style } from 'typestyle'

/* Common ======================================================================================= */
import { get } from '../../../share/find'
import { setCurrentUser } from '../../../services/auth'

/* Hooks ======================================================================================== */
import useValue from '../../../hooks/use-value'
import useFetch from '../../../hooks/use-fetch'
import useCounter from '../../../hooks/use-counter'

/* Components =================================================================================== */
import AuthenticationLayout from '../user-signin/components/auth.layout'
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Circle } from '../../../components/circle'
import { Form } from '../../../components/form'
import { Heading } from '../../../components/text/heading.component'
import { Line } from '../../../components/line'
import { Link } from 'react-router-dom'
import { RichTextView } from '../../../components/field-editor-field/view/richt-text-view'
import { Text } from '../../../components/text/text.component'
import { renderForm } from '../../../modules/handlers/render-form'

/* Constants ==================================================================================== */
import { mb16 } from '../../../styles/styleset/margin/mb16'
import { mb20 } from '../../../styles/styleset/margin/mb20'
import { ml8 } from '../../../styles/styleset/margin/ml8'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { p16 } from '../../../styles/styleset/padding/p16'
import { paddingVerticalInner } from '../../../styles/default/padding'
import { pb16 } from '../../../styles/styleset/padding/pb16'
import { primaryMediumi } from '../../../styles/styleset/primary-medium/primaryMediumi'
import { pt16 } from '../../../styles/styleset/padding/pt16'
import { textCenter } from '../../../styles/styleset/text-center/textCenter'
import { w100 } from '../../../styles/styleset/width/w100'
import { mt16 } from '../../../styles/styleset/margin/mt16'
import { mt20 } from '../../../styles/styleset/margin/mt20'
import { GLOBAL_CONTENTS } from '../../../common/global-contents'
import useLocal from '../../../hooks/use-local'

let tempValue: any = {}

/* <RegisterForm /> ============================================================================= */
const RegisterForm = (props: { eject: any }) => {
  const { eject } = props
  const [meta, $meta] = useFetch(
    {
      base: {
        sections: [],
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/users/signup`,
    },
  )

  const [, $a] = useFetch(
    {
      body: {
        body: [],
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/users/signup`,
    },
  )

  const [policy, $policy] = useFetch(
    {
      id: '',
      body: {
        content: '',
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/policy`,
    },
  )
  const history = useNavigate()
  const [counter, $counter] = useCounter(0, { min: 0, max: 4 })
  const [value, $value] = useValue({})
  const [error] = useValue()
  const [local] = useLocal()
  const sections = get('base.sections', meta.payload, 'array')
  let timeoutId: number

  useEffect(() => {
    return () => {
      eject()
    }
  }, [])

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId)
    }
  }, [])

  useEffect(() => {
    if (meta.mounted) {
      $meta.get()
    }
  }, [meta.mounted])

  useEffect(() => {
    if (policy.mounted) {
      $policy.get()
    }
  }, [policy.mounted])

  const exit = (payload: any) => {
    $value.set({})
    tempValue = {}

    setTimeout(() => {
      history(`/a/verify-form/${payload.currentUser.verificationToken}`)
    }, 2000)
  }

  const renderProgress = () => {
    return (
      <Box className={mb20} flex>
        {sections.map((section: any, key: any) => {
          return (
            <Box className={mr8} flex alignCenterY fullWidth={counter === key} key={key}>
              <Circle baseline={counter === key ? 'primary' : 'disabled'} size="xs">
                <Text
                  size="xs"
                  semiBold
                  baseline={counter === key ? 'primary' : 'disabled'}
                  disableMediaQuery
                >
                  {key + 1}
                </Text>
              </Circle>
              {counter === key && (
                <Text className={ml8} size="md">
                  {section.label}
                </Text>
              )}
            </Box>
          )
        })}
        <Box className={mr8} flex alignCenterY fullWidth={counter === 3}>
          <Circle baseline={counter === 3 ? 'primary' : 'disabled'} size="xs">
            <Text size="xs" semiBold baseline={counter === 3 ? 'primary' : 'disabled'}>
              {4}
            </Text>
          </Circle>
          {counter === 3 && (
            <Text className={ml8} size="md" semiBold>
              {GLOBAL_CONTENTS.done[local]}
            </Text>
          )}
        </Box>
      </Box>
    )
  }

  const renderActions = () => {
    switch (counter) {
      case 0:
        return (
          <Box alignRight column className={classes(mt16, w100)}>
            <Button
              className={mr8}
              baseline="surface"
              label={GLOBAL_CONTENTS.cancel[local]}
              size="md"
              square
              onClick={() => {
                history('/a/signin')
              }}
            />
            <Button
              label={GLOBAL_CONTENTS.accept[local]}
              baseline="primary"
              size="md"
              square
              type="submit"
            />
          </Box>
        )
      case $counter.getMax() - 1:
        return <Box alignRight column className={classes(mt16, w100)}></Box>
      default:
        return (
          <Box alignRight column className={classes(mt16, w100)}>
            <Button
              className={mr8}
              label={GLOBAL_CONTENTS.prev[local]}
              baseline="background"
              size="md"
              square
              onClick={() => $counter.decrement()}
            />
            <Button
              label={GLOBAL_CONTENTS.next[local]}
              baseline="primary"
              size="md"
              square
              type="submit"
            />
          </Box>
        )
    }
  }

  const drawForm = () => {
    switch (counter) {
      case 0:
        return (
          <Form
            key={0}
            name="agreement"
            onSubmit={() => {
              $value.set((prev: any) => ({ ...prev, terms: { policy: policy.payload.id } }))
              $counter.increment()
            }}
          >
            <Box minHeight={296} maxHeight={296} baseline="background" rounded row>
              <RichTextView __html={policy.payload.body.content} />
            </Box>
            {error && (
              <>
                <hr />
                <Text>{error}</Text>
                <hr />
              </>
            )}
            {renderActions()}
          </Form>
        )
      case $counter.getMax() - 1:
        return (
          <Form
            key={3}
            onSubmit={() => {
              $counter.increment()
            }}
          >
            <Box
              className={p16}
              baseline="background"
              minHeight={296}
              // minWidth={320}
              // maxWidth={320}
              rounded
              row
              alignCenterY
            >
              <Box baseline="none" alignCenterX row>
                <Heading className={classes(mb16, textCenter)} size="xs">
                  {GLOBAL_CONTENTS.thankSignUp[local]}
                </Heading>
              </Box>
              <Box baseline="none" row flex alignCenterX>
                <Heading className={textCenter} size="xs">
                  {GLOBAL_CONTENTS.afterSignUp[local]}
                </Heading>
                <Box className={mt20} baseline="none">
                  <span
                    className={classes(
                      process.env.REACT_APP_GOOGLE_MATERIAL_ICONS,
                      style({
                        fontSize: 20,
                        background: 'none',
                        animationDuration: '4s',
                        animationIterationCount: 'infinite',
                        animationName: keyframes({
                          '100%': {
                            transform: 'rotate(360deg)',
                          },
                        }),
                      }),
                    )}
                  >
                    hourglass_empty
                  </span>
                </Box>
              </Box>
            </Box>
          </Form>
        )
      default:
        return (
          <Form
            key={1}
            name="generalInformation"
            values={value.generalInformation || tempValue.generalInformation}
            onSubmit={(data: any) => {
              if (counter < $counter.getMax() - 2) {
                $value.set((prev: any) => ({
                  ...prev,
                  generalInformation: { ...prev.generalInformation, ...data },
                }))
              } else {
                if (Object.keys(data).length > 0) {
                  $value.set((prev: any) => ({
                    ...prev,
                    generalInformation: { ...prev.generalInformation, ...data },
                  }))
                  $a.post({ body: { ...value, generalInformation: data } }).then((payload: any) => {
                    setCurrentUser(payload)
                    exit(payload)
                  })
                } else {
                  $a.post({ body: value }).then((payload: any) => {
                    setCurrentUser(payload)
                    exit(payload)
                  })
                }
              }

              $counter.increment()
            }}
            onChange={(data: any) => {
              tempValue = { ...tempValue, generalInformation: data }
            }}
          >
            <Box minWidth={320}>
              {sections[counter].fields.map((field: any) => {
                return renderForm({
                  field,
                  parentName: '',
                  entryUrl: `${process.env.REACT_APP_API_URL}/app`,
                })
              })}
            </Box>
            {error && (
              <>
                <hr />
                <Text>{error}</Text>
                <hr />
              </>
            )}
            {renderActions()}
          </Form>
        )
    }
  }

  return (
    <AuthenticationLayout title={GLOBAL_CONTENTS.signUp[local]}>
      <Box baseline="none" className={classes(paddingVerticalInner, pt16, pb16)}>
        {renderProgress()}
        {drawForm()}
      </Box>
      <Box baseline="none" row>
        <Line />
      </Box>
      <Box baseline="none" className={classes(paddingVerticalInner, pt16, pb16)} alignCenterX>
        <Text>
          {GLOBAL_CONTENTS.haveAccount[local]}{' '}
          <Text link>
            <Link to={'/a/signin'} className={primaryMediumi}>
              {GLOBAL_CONTENTS.clickHere[local]}
            </Link>
          </Text>
        </Text>
      </Box>
    </AuthenticationLayout>
  )
}

export default RegisterForm
